// extracted by mini-css-extract-plugin
module.exports = {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","SearchResults":"jt_a bhs_a bhs_j bhs_q bhs_rp bhs_rq bhs_w"};